import { User } from '@/models/user.model'
import { api } from '@/services/api'

export type FindUserByIdResponse = {
  user: User
}

export async function findUserById(userId: string) {
  const response = await api.get<FindUserByIdResponse>(`/users/${userId}`)
  return response.data
}

export async function updateOnFirebase(id: string, dataToUpdate: Partial<User>) {
  await api.put('/users', { id, dataToUpdate })
}
